export default __webpack_public_path__ + "static/go_with_auvelity-aeca850cb23e2638cf87ca470c9fb306.png";